import React, { useMemo, useCallback } from 'react';
import { BaseFilter, BaseFilterState, FilterConfig } from '../../../shared/ui';
import { PaymentV2Filters } from '../../../api/paymentsV2Api';
import './UserPaymentsFilter.css';

interface UserPaymentsFilterProps {
  filters: PaymentV2Filters;
  onFiltersChange: (filters: PaymentV2Filters) => void;
  loading?: boolean;
  className?: string;
}

const UserPaymentsFilter: React.FC<UserPaymentsFilterProps> = ({ 
  filters, 
  onFiltersChange, 
  loading = false,
  className = ''
}) => {
  // Конфигурация фильтров для "Мои платежи" - только период
  const filterConfig: FilterConfig[] = useMemo(() => [
    { type: 'period', label: 'Период', enabled: true }
  ], []);

  // Преобразуем локальное состояние в базовое
  const baseFilters: BaseFilterState = useMemo(() => ({
    startDate: filters.startDate,
    endDate: filters.endDate
  }), [filters.startDate, filters.endDate]);

  // Обработчик изменений фильтров
  const handleBaseFiltersChange = useCallback((newFilters: BaseFilterState) => {
    // Преобразуем базовые фильтры обратно в локальное состояние
    const updatedFilters: PaymentV2Filters = {
      startDate: newFilters.startDate,
      endDate: newFilters.endDate
    };
    
    onFiltersChange(updatedFilters);
  }, [onFiltersChange]);

  return (
    <div className={`user-payments-filter ${className}`}>
      <BaseFilter
        filters={baseFilters}
        onFiltersChange={handleBaseFiltersChange}
        filterConfig={filterConfig}
        showLoading={loading}
      />
    </div>
  );
};

export default UserPaymentsFilter;

